type Metrics = {
  /** 今の scrollTop */
  scrollTop: number;
  /** スクロールするコンテナの上端（ビューポート座標） */
  containerTop: number;
  /** 見せたい行の上端（ビューポート座標） */
  rowTop: number;
  /** コンテナ内の固定ヘッダの高さ。行がこの裏に潜らないよう避ける */
  headerHeight: number;
  /** これ以上はスクロールできない値（scrollHeight - clientHeight） */
  maxScrollTop: number;
};

/**
 * 選んだ行をヘッダのすぐ下へ持ってくるための scrollTop。
 *
 * Why not scrollIntoView({ block: 'nearest' }): 上にある行は固定ヘッダ（全選択など）の
 * 下に潜り、下にある行は一覧の最下端に貼り付く。どちらも「選んだ行はどれか」が読めない。
 */
export function resolveRowScrollTop({
  scrollTop, containerTop, rowTop, headerHeight, maxScrollTop,
}: Metrics): number {
  const target = scrollTop + (rowTop - containerTop) - headerHeight;
  // 先頭より上・末尾より下へは動かせない
  return Math.max(0, Math.min(target, maxScrollTop));
}
